<template>
  <div>
    {{ ActDescBtn }}
    <v-container class="pa-0" fluid>
      <!-- Toolbar -->
      <v-row style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Visualiza multiples estadisticas de un cliente seleccionado'"
          :show-absolute="false"
          :titulo="'Estadisticas de Clientes'"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodNuevo="newnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </v-row>
      <!-- fn Toolbar  -->

      <v-row>
        <!-- Barra de busqueda --->
        <v-col v-show="BarraPrimariaAbrir" :max-height="this.windowSize.height - 96" cols="3">
          <div
            class="overflow-y-auto"
            v-bind:style="{
              'max-height': this.windowSize.height - 96 + 'px',
            }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <!-- <v-navigation-drawer >  -->
                <div class="d-flex justify-center">
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px"></i>
                      ver
                    </v-btn>

                    <v-btn
                      color="teal darken-2"
                      dark
                      small
                      text
                      @click.prevent="
                        ;(dialogFiltros = true), (ObjTemTbDinam = JSON.parse(JSON.stringify(Modallfiltro)))
                      "
                    >
                      <i class="fa fa-search" style="font-size: 25px"></i>
                      Filtrar
                    </v-btn>
                  </v-btn-toggle>
                </div>

                <BarraDinamicaLimitePlus
                  :ContListSlot="[
                    { Text: 'Codigo', NomValue: 'codigo', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Nombre', NomValue: 'nombre', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Estado', NomValue: 'activado', Ctsl: 1, Type: 0.1, State: true },
                  ]"
                  :PropsList="clienteList"
                  :PropsNombre="'Buscar Cliente'"
                  :PropsSeachNombre="'Búsqueda por nombre'"
                  :TbPaginator="TbPaginator"
                  :TbTotalItem="totalItems"
                  :headers="[{ text: 'Código', value: 'codigo' }]"
                  PropsSearch
                  @CargarPaginacion="CargarPaginacion"
                  @EmitDAta="datostabla"
                />
              </template>
            </v-tooltip>
          </div>
        </v-col>
        <!-- fn Barra de busqueda --->

        <!-- Contenido central --->
        <v-col :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto px-3"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <v-card class="px-2" color="grey lighten-3">
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="cliente.nombre"
                    dense
                    label="Cliente"
                    outlined
                    placeholder="N/A"
                    readonly
                    type="text"
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-user" style="font-size: 20px; width: 20px"></i>
                    </template>
                  </v-text-field>

                  <div class="px-2">
                    <h3>Informacion de mayor pedido</h3>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Factura</th>
                            <th class="text-left">Fecha</th>
                            <th class="text-left">Dias de Pago</th>
                            <th class="text-left">Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ mayorPedido.factura }}</td>
                            <td>{{ mayorPedido.fecha }}</td>
                            <td>{{ mayorPedido.diasPago }}</td>
                            <td>{{ mayorPedido.valor }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <div></div>
                  </div>
                </v-col>

                <v-col>
                  <v-textarea v-model="cliente.comentario" dense label="Comentario" outlined placeholder="N/A" readonly>
                    <template v-slot:prepend>
                      <i class="fa fa-commenting" style="font-size: 20px"></i>
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <!-- columna 1 -->
                <v-col cols="12" md="6">
                  <div class="px-2">
                    <h3>Productos más comprados</h3>
                    <v-data-table
                      :footer-props="footerProps"
                      :headers="productoHeaders"
                      :items="productosMasCompradosPage.content"
                      :items-per-page="5"
                      dense
                      no-data-text="No hay productos"
                    ></v-data-table>
                  </div>

                  <div class="px-2">
                    <h3>Recibos de pago</h3>
                    <v-data-table
                      :key="cliente.codigo"
                      :footer-props="footerProps"
                      :headers="recibosDePagoHeaders"
                      :items="recibosDePagoPage.content"
                      :items-per-page="5"
                      :server-items-length="recibosDePagoPage.totalElements"
                      dense
                      no-data-text="No hay recibos de pago"
                      @update:page="recibosDeIngreso"
                    ></v-data-table>
                  </div>

                  <div class="px-2">
                    <h3>Cheques devueltos pendientes</h3>
                    <v-data-table
                      :key="cliente.codigo"
                      :footer-props="footerProps"
                      :headers="chequesDevueltosHeaders"
                      :items="chequesDevueltosPendientesPage.content"
                      :items-per-page="5"
                      :server-items-length="chequesDevueltosPendientesPage.totalElements"
                      dense
                      no-data-text="No hay cheques devueltos pendientes"
                      @update:page="chequesDevueltosPendientes"
                    ></v-data-table>
                  </div>
                </v-col>
                <!-- fn columna 1 -->

                <!-- columna 2 -->
                <v-col cols="12" md="6">
                  <div class="px-2">
                    <h3>Facturas pendientes</h3>
                    <v-data-table
                      :key="cliente.codigo"
                      :footer-props="footerProps"
                      :headers="facturasPendientesHeaders"
                      :items="facturasPendientesPage.content"
                      :items-per-page="5"
                      :server-items-length="facturasPendientesPage.totalElements"
                      dense
                      no-data-text="No hay facturas pendientes"
                      @update:page="facturasPendientes"
                    ></v-data-table>
                  </div>

                  <div class="px-2">
                    <h3>Facturas saldadas</h3>
                    <v-data-table
                      :key="cliente.codigo"
                      :footer-props="footerProps"
                      :headers="facturasPendientesHeaders"
                      :items="facturasSaldadasPage.content"
                      :items-per-page="5"
                      :server-items-length="facturasSaldadasPage.totalElements"
                      dense
                      no-data-text="No hay facturas saldadas"
                      @update:page="facturasSaldadas"
                    ></v-data-table>
                  </div>

                  <div class="px-2">
                    <h3>Cheques devueltos pagados</h3>
                    <v-data-table
                      :key="cliente.codigo"
                      :footer-props="footerProps"
                      :headers="chequesDevueltosHeaders"
                      :items="chequesDevueltosPagadosPage.content"
                      :items-per-page="5"
                      :server-items-length="chequesDevueltosPagadosPage.totalElements"
                      dense
                      no-data-text="No hay cheques devueltos pagados"
                      @update:page="chequesDevueltosPagados"
                    ></v-data-table>
                  </div>
                </v-col>
                <!-- fn columna 2 -->
              </v-row>
            </v-card>
          </v-app>
        </v-col>
        <!-- fn Contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>

    <!-- Modales -------------------------------------------------------------------------------------------------->
    <v-dialog
      v-model="acti_tb_data"
      fullscreen
      hide-overlay
      label="myAlert"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" dense flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>

          <v-btn color="grey darken-4" fab small @click="actualiza_tb_ver">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="Modallfiltro.cliente"
                autocomplete="off"
                hide-details
                label="Buscar"
                single-line
                @keyup="CargarListTb"
              >
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="[
                {
                  text: 'Código',
                  sortable: false,
                  value: 'codigo',
                  class: ['black--text'],
                },
                {
                  text: 'Nombre',
                  sortable: false,
                  value: 'nombre',
                  width: 250,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Cedula/Rnc:',
                  sortable: false,
                  value: 'cedrnc',
                  width: 130,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Fec.nacimiento',
                  sortable: false,
                  value: 'fechanacimiento',
                  width: 150,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Email:',
                  sortable: false,
                  value: 'email',
                  width: 120,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Ciudad',
                  sortable: false,
                  value: 'ciudad',
                  width: 150,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Dirección',
                  sortable: false,
                  value: 'direccion',
                  width: 250,
                  class: ['no-gutters black--text'],
                },
                // { text: 'pais', sortable: false,  value: 'pais.nombre', width: 150 },
                {
                  text: 'Cerca de:',
                  sortable: false,
                  value: 'cercade',
                  width: 250,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Paraje:',
                  sortable: false,
                  value: 'paraje',
                  width: 250,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Otra Ubicación:',
                  sortable: false,
                  value: 'otraubicacion',
                  width: 250,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Donde Trabaja:',
                  sortable: false,
                  value: 'dondetrabaja',
                  width: 120,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Ref. Comercial #1:',
                  sortable: false,
                  value: 'referenciacomercial',
                  width: 250,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Ref. Comercial #2:',
                  sortable: false,
                  value: 'referenciacomercial2',
                  width: 250,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Ref. Personal #1:',
                  sortable: false,
                  value: 'referenciapersonal',
                  width: 250,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Ref. Personal #2:',
                  sortable: false,
                  value: 'referenciapersonal2',
                  width: 250,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Aviso/Alerta',
                  sortable: false,
                  value: 'avisoalerta',
                  width: 120,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Comentario',
                  sortable: false,
                  value: 'comentario',
                  width: 250,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Fecha Ingreso',
                  sortable: false,
                  value: 'fechaingreso',
                  width: 150,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Días de Crédito',
                  sortable: false,
                  value: 'diascredito',
                  width: 120,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Lím.Crédito',
                  sortable: false,
                  value: 'limitecredito',
                  width: 120,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Tipo de Cliente',
                  sortable: false,
                  value: 'tipocliente.descripcion',
                  width: 120,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'vendedores',
                  sortable: false,
                  value: 'vendedores.nombre',
                  width: 120,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Zona',
                  sortable: false,
                  value: 'zona',
                  width: 120,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'tipo',
                  sortable: false,
                  value: 'tipo',
                  width: 120,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Estatus',
                  sortable: false,
                  value: 'statuscliente',
                  width: 120,
                  class: ['no-gutters black--text'],
                },
                {
                  text: 'Activo',
                  sortable: false,
                  value: 'activado',
                  width: 120,
                  class: ['no-gutters black--text'],
                },
              ]"
              :items="clienteList"
              :items-per-page="TbPaginator.itemsPerPage"
              :page="TbPaginator.page"
              :pageCount="TbPaginator.pageCount"
              :search="Modallfiltro.cliente"
              :server-items-length="totalItems"
              class="TbSize13"
              dense
              @pagination="cargarPaginacionAll"
              @click:row="datostabla"
            >
              <template v-slot:item.activado="props">
                <span v-if="props.item.activado == true" style="font-size: 13px">Activo</span>
                <span v-if="props.item.activado == false" style="font-size: 13px">In-Activo</span>
              </template>

              <template v-slot:item.fechanacimiento="props">
                <span style="font-size: 13px">{{ fecFormatter(props.item.fechanacimiento) }}</span>
              </template>

              <!-- <template v-slot:item.nombre="props">
                    <span style="font-size:13px;" >{{props.item.nombre}}</span>
                  </template> -->
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn tb-data todo general -->

    <!-- ------------------------------------------------------ notif-->
    <v-dialog v-model="notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn v-if="notif.Exec == 'AnularCaja'" small @click.prevent="eliminar(), (notif.estado = !notif.estado)">
            <i class="fa fa-check" style="font-size: 20px"></i>
            Si
          </v-btn>

          <v-btn small @click.prevent="notif.estado = !notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn notif -->

    <!-- ------------------------------------------------------   alerta -->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->

    <!-- ------------------------------------------------------ Modal-Filtro tb-datos -->
    <v-dialog
      v-model="dialogFiltros"
      label="Modal agregar factura"
      max-height="50%"
      max-width="60%"
      persistent
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="indigo" dense flat>
          <i class="" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light" style="color: white">
            <b>FILTROS</b>
          </v-toolbar-title>
          <i class="" style="font-size: 20px"></i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click=";(dialogFiltros = false), (Modallfiltro = JSON.parse(JSON.stringify(ObjTemTbDinam)))"
          >
            <i class="fa fa-close" style="font-size: 20px; color: white"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <br />

          <v-row>
            <v-col cols="12" md="12">
              <!-------------------------------------------------- Nombre  -->
              <v-text-field v-model="Modallfiltro.cliente" autocomplete="off" dense label="Nombre" outlined>
                <template v-slot:prepend>
                  <i class="fa fa-font" style="font-size: 20px"></i>
                </template>
              </v-text-field>

              <!-- ----------------------------- Tipo de Cliente -->
              <v-autocomplete
                v-model="Modallfiltro.tipocliente"
                :items="tipoClienteList"
                autocomplete="off"
                dense
                item-text="descripcion"
                label="Tipo de Cliente:"
                outlined
                return-object
                @focus.once="findAllTipoCliente"
              >
                <template v-slot:prepend>
                  <i class="fa fa-users" style="font-size: 20px"></i>
                </template>
              </v-autocomplete>

              <!------------------------------------------------ cliende de seguro -->
              <v-switch
                v-model="Modallfiltro.Clseguro"
                color="success"
                hide-detail
                label="Solo Clientes de Seguro"
              ></v-switch>

              <!------------------------------------------------ cliende de activos -->
              <v-switch v-model="Modallfiltro.activos" color="success" hide-detail label="Activos"></v-switch>
              <center>
                <v-radio-group v-model="Modallfiltro.opcion" class="mt-0" row>
                  <!-- <v-row></v-row>
                          <v-col cols="12" md="6"></v-col> -->
                  <!-- <v-col cols="12" md="6"></v-col> -->
                  <v-radio :value="1" color="green" label="Todo"></v-radio>
                  <v-radio :value="2" color="green" label="Contado"></v-radio>
                  <v-radio :value="3" color="green" label="Crédito"></v-radio>
                </v-radio-group>
              </center>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn-toggle dense rounded>
            <v-btn color="#90A4AE" @click.prevent="Limpiarfiltro">
              <i class="fa fa-file-o" style="font-size: 28px"></i>
              Limpiar filtro
            </v-btn>

            <v-btn color="blue lighten-1" @click.prevent="BuscarFiltros">
              <i class="fa fa-search" style="font-size: 28px"></i>
              Buscar
            </v-btn>
          </v-btn-toggle>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-Filtro tb-datos -->
    <!-- ------------------------------------------------------ fn Modal-Reportes-ModalReporteFiltros -->
    <div v-if="ejecucion" class="form-loading-indicator">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import Autonumeric from "../components/AutoNumericNuevo"
  import BarraDinamicaLimitePlus from "../components/BarraDinamicaLimitePlus"
  import BarraBusqueda2 from "../components/BarraBusquedaDinamLimite"
  import BarraDinamicaLimite from "../components/BarraDinamicaLimite"
  import { EventBus } from "@/event-bus"
  import ContenidoBase from "../components/ContenidoBase"
  import ModalReporteBasico from "../components/ModalReporteBasico"
  import ModalReporteFiltros from "../components/ModalReporteFiltros"
  import { currencyFormatter, fechaNueva, FormatoFecha, getParamFecha, HoraFormatter } from "@/js/Funciones.js"

  export default {
    components: {
      BarraDinamicaLimite,
      BarraDinamicaLimitePlus,
      BarraBusqueda2,
      Autonumeric,
      ContenidoBase,
      ModalReporteBasico,
      ModalReporteFiltros,
    },

    mounted() {
      console.log("Mount-Inf")
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      //EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      EventBus.$on("emitAnular", this.datostabla)
      EventBus.$on("AnularNew", this.new)
      // EventBus.$on("AnularSave", this.save);
      EventBus.$on("AnularRemove", this.remove)
      EventBus.$on("AnularAnular", this.save)
      Object.assign(this.cliente, this.clienteNuevo)
    },

    created() {},

    data() {
      return {
        windowSize: { width: "auto", height: "auto" },

        EstadoBtn: {
          BarraTablaDinamicaAprir: true,
          nuevo: false,
          guardar: false,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        },

        RCliente: [],
        RVer: null,
        texAria: null,
        valid: true,

        dialogFiltros: false,
        Modallfiltro: {
          cliente: null,
          tipocliente: null,
          Clseguro: false,
          activos: true,
          opcion: 1,
        },

        // Formulario
        clienteNuevo: {
          codigo: 0,
          nombre: "",
          cedrnc: "",
          comentario: "",
        },

        cliente: {
          codigo: 0,
        },

        // Listados
        clienteList: [],
        tipoClienteList: [],
        totalItems: 0,

        // Mayor pedido
        mayorPedido: {
          factura: "",
          valor: null,
          fecha: "",
          cantidadPagos: null,
          diasPago: null,
        },

        // Productos mas comprados
        productosMasCompradosPage: {
          content: [],
        },
        productoHeaders: [
          { text: "Código", value: "codigoProducto", sortable: false },
          { text: "Descripción", value: "descripcionProducto", sortable: false },
          { text: "Cantidad", value: "cantidad", sortable: false },
        ],
        footerProps: { disableItemsPerPage: true, itemsPerPageText: "" },

        // Recibos de pago
        recibosDePagoPage: {
          content: [],
          totalElements: 0,
        },

        recibosDePagoHeaders: [
          { text: "Recibo", value: "reciboIngreso", sortable: false },
          { text: "Fecha Rec.", value: "fecha", sortable: false },
          { text: "Factura", value: "factura", sortable: false },
          { text: "Dias de Pago", value: "diasPago", sortable: false },
          { text: "Valor", value: "valor", sortable: false },
        ],

        // Facturas pendientes
        facturasPendientesPage: {
          content: [],
          totalElements: 0,
        },
        facturasPendientesHeaders: [
          { text: "Factura", value: "descripcion", sortable: false },
          { text: "Fecha", value: "fecha", sortable: false },
          { text: "Dias", value: "dias", sortable: false },
          { text: "Pendiente", value: "pendiente", sortable: false },
        ],

        // Facturas saldadas
        facturasSaldadasPage: {
          content: [],
          totalElements: 0,
        },

        // Cheques devueltos pendientes
        chequesDevueltosPendientesPage: {
          content: [],
          totalElements: 0,
        },
        chequesDevueltosHeaders: [
          { text: "Cheque", value: "cheque", sortable: false },
          { text: "Fecha", value: "fecha", sortable: false },
          { text: "Dias", value: "dias", sortable: false },
          { text: "Pendiente", value: "pendiente", sortable: false },
        ],

        // Cheques devueltos pagados
        chequesDevueltosPagadosPage: {
          content: [],
          totalElements: 0,
        },

        ObjTemTbDinam: null,
        TbTotalItem: 0,
        TbPaginator: {
          page: 1,
          itemsPerPage: 5,
          pageStart: 1,
          pageStop: 15,
          pageCount: 10,
          itemsLength: 5,
        },
        headers: [{ text: "#Factura", value: "facturasventaPK.secuencia" }],

        acti_tb_data: false,
        paginator: {
          itemsPerPage: 15,
          pageStart: 1,
          page: 1,
          pageStop: 15,
          pageCount: 10,
          itemsLength: 5,
        },

        ejecucion: false,
        aalert: {
          estado: false,
          color: null,
        },

        notif: {
          estado: false,
          nombre: "",
          Exec: "",
        },

        BarraPrimariaAbrir: false,
      }
    },
    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      fechaNueva,
      getParamFecha,
      cargarCliente() {
        this.$axios
          .get(this.$hostname + this.$hName + "/clientes/findCombo/A/25", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => (this.RCliente = res.data))
      },

      CbFilcliente(e) {
        this.RCliente = []
        if (e.target.value.length >= 0) {
          this.$axios
            .get(
              this.$hostname +
                this.$hName +
                "/clientes/findtodo/" +
                (e.target.value === null || e.target.value.length == 0 ? "A" : e.target.value) +
                "/3/25/0",
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => {
              this.RCliente = res.data
            })
        }
      },

      // Al verificar si el cliente es nulo, si es nulo, establece el cliente en una cadena vacía.
      SelctCbCliente() {
        if (this.Modallfiltro.cliente == null) {
          this.Modallfiltro.cliente = ""
        }

        if (this.Modallfiltro.cliente.codigo == undefined) {
          this.alerta("Seleccione un cliente", "error")
          this.Modallfiltro.cliente = ""

          //qlq2

          return
        }
      },

      // Abriendo una la barra de datos principal.
      abrirTabla() {
        this.BarraPrimariaAbrir = !this.BarraPrimariaAbrir

        if (this.abrirTablaDinamica) {
          this.Limpiarfiltro()
        }
      },

      alerta(e, l) {
        if (l == "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e
          this.newnuevo()
        }

        if (l == "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e
          EventBus.$emit("loading", false)
        }
      },

      // Limpia el formulario.
      newnuevo() {
        Object.assign(this.cliente, this.clienteNuevo)
        this.ejecucion = false
      },

      save() {},

      remove() {
        this.Elim_notif.estado = !this.Elim_notif.estado
      },

      eliminar() {},

      fecFormatter(params) {
        if (params != null) {
          if (params.length > 0) {
            return params.substring(8, 10) + "-" + params.substring(5, 7) + "-" + params.substring(0, 4)
          }
        }
      },

      // Se llama cuando se hace clic en una fila de la tabla.
      datostabla(e) {
        this.cliente = e
        this.acti_tb_data = false

        this.mayorPedidoCliente()

        this.productosMasComprados()
        this.recibosDeIngreso(1)
        this.chequesDevueltosPendientes(1)

        this.facturasPendientes(1)
        this.facturasSaldadas(1)
        this.chequesDevueltosPagados(1)
      },

      // Un metodo que se llama cuando se hace clic en un boton y muestra un modal con todo los registro.
      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.Limpiarfiltro()
      },

      // Limpieza del filtro y recarga los datos de la tabla.
      Limpiarfiltro() {
        var Pg = {
          itemsLength: this.TbPaginator.itemsLength,
          itemsPerPage: this.TbPaginator.itemsPerPage,
          page: 1,
          pageCount: 1,
          pageStart: 0,
          pageStop: this.TbPaginator.itemsPerPage,
        }

        this.Modallfiltro = {
          Clseguro: false,
          activos: true,
          cliente: null,
          tipocliente: null,
          opcion: 1,
        }

        this.TbPaginator = JSON.parse(JSON.stringify(Pg))
        this.CargarListTb()
        this.dialogFiltros = false
      },

      // Una función que se llama cuando el usuario hace clic en el botón de búsqueda y ejecuta un a api retornando los datos.
      BuscarFiltros() {
        var Pg = {
          itemsLength: this.TbPaginator.itemsLength,
          itemsPerPage: this.TbPaginator.itemsPerPage,
          page: 1,
          pageCount: 1,
          pageStart: 0,
          pageStop: this.TbPaginator.itemsPerPage,
        }

        this.TbPaginator = JSON.parse(JSON.stringify(Pg))
        this.CargarListTb()
        this.dialogFiltros = false
      },

      // Se llama cuando el usuario cambia la cantidad de elementos por página en el
      // componente de paginación.
      cargarPaginacionAll(e) {
        if (e.itemsPerPage == -1) {
          e.itemsPerPage = 15
        }
        this.CargarPaginacion(e, this.Modallfiltro.factura)
      },

      // Se llama cuando el usuario cambia la página de la tabla.
      CargarPaginacion(e, s) {
        if (e.itemsPerPage == -1) {
          e.itemsPerPage = 15
        }
        this.Modallfiltro.cliente = JSON.parse(JSON.stringify(s))
        this.TbPaginator = JSON.parse(JSON.stringify(e))
        this.CargarListTb()
      },

      // Obtener los datos de la lista
      CargarListTb() {
        let tipo = null
        if (this.Modallfiltro.tipocliente != null) {
          tipo = this.Modallfiltro.tipocliente.codigo
        }
        let obj =
          this.TbPaginator.itemsPerPage +
          "/" +
          this.TbPaginator.pageStart +
          "/" +
          this.Modallfiltro.cliente +
          "/" +
          tipo +
          "/" +
          this.Modallfiltro.Clseguro +
          "/" +
          this.Modallfiltro.activos +
          "/" +
          this.Modallfiltro.opcion

        this.$axios
          .get(this.$hostname + this.$hName + "/clientes/findListClientePlus/" + obj, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.clienteList = res.data.ListCliente
            this.totalItems = res.data.TbTotalItem
          })
      },

      findAllTipoCliente(value) {
        this.$axios
          .get(this.$hostname + this.$hName + "/tipoclientes/findallActivo", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.tipoClienteList = res.data
          })
      },

      mayorPedidoCliente() {
        this.$axios
          .get(this.$hostname + this.$hName + "/facturasventas/cliente/mayorPedido", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              codigo: this.cliente.codigo,
            },
          })
          .then((res) => {
            Object.assign(this.mayorPedido, res.data)
          })
      },

      productosMasComprados() {
        this.$axios
          .get(this.$hostname + this.$hName + "/facturasventas/productosMasComprados", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              codigo: this.cliente.codigo,
            },
          })
          .then((res) => {
            this.productosMasCompradosPage = res.data
          })
      },

      facturasPendientes(page) {
        this.$axios
          .get(this.$hostname + this.$hName + "/facturasventas/facturasPendientes", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              codigo: this.cliente.codigo,
              page: page - 1,
              size: 5,
            },
          })
          .then((res) => {
            this.facturasPendientesPage = res.data
          })
      },

      facturasSaldadas(page) {
        this.$axios
          .get(this.$hostname + this.$hName + "/facturasventas/facturasSaldadas", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              codigo: this.cliente.codigo,
              page: page - 1,
              size: 5,
            },
          })
          .then((res) => {
            this.facturasSaldadasPage = res.data
          })
      },

      recibosDeIngreso(page) {
        this.$axios
          .get(this.$hostname + this.$hName + "/reciboingreos/recibosDePago", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              codigo: this.cliente.codigo,
              page: page - 1,
              size: 5,
            },
          })
          .then((res) => {
            this.recibosDePagoPage = res.data
          })
      },

      chequesDevueltosPendientes(page) {
        this.$axios
          .get(this.$hostname + this.$hName + "/notadebitocliente/chequesDevueltosPendientes/cliente", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              codigo: this.cliente.codigo,
              page: page - 1,
              size: 5,
            },
          })
          .then((res) => {
            this.chequesDevueltosPendientesPage = res.data
          })
      },

      chequesDevueltosPagados(page) {
        this.$axios
          .get(this.$hostname + this.$hName + "/notadebitocliente/chequesDevueltosPagados/cliente", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              codigo: this.cliente.codigo,
              page: page - 1,
              size: 5,
            },
          })
          .then((res) => {
            this.chequesDevueltosPagadosPage = res.data
          })
      },
    },

    computed: {
      ActDescBtn() {
        this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
      },
    },
  }
</script>

<style></style>
